import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { AuthenticationService } from "../../services/authentication.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { first } from "rxjs/operators";
import { CajaService } from "../../services/caja.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "login.component.html",
  styleUrls: [
    "../../../../node_modules/ladda/dist/ladda-themeless.min.css",
    "login.component.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {
  isLoading: boolean = false;
  submitted = false;
  loginForm: FormGroup;
  returnUrl: string;
  messageError: undefined;
  constructor(
    private auth: AuthenticationService,
    private formBuilder: FormBuilder,
    public router: Router,
    private srvRoute: ActivatedRoute,
    private srvCaja: CajaService
  ) {}

  ngOnInit() {
    this.srvRoute.paramMap.subscribe(
      (params) => {
        localStorage.clear();

          // Primer token
        if (params.has("valueEncpt")) {
          const token = params.get("valueEncpt");
          localStorage.setItem("token", JSON.stringify(token));

          // BackOffice token
        if (params.has("boToken")) {
          const boToken = params.get("boToken");
          localStorage.setItem("boToken", JSON.stringify(boToken));
        }
          // INICIO
          this.auth.confirmarToken(token).subscribe(
            (result) => {
              const { Menu, Info } = result;

              // insertar en localStorage

              localStorage.setItem("menu", JSON.stringify(Menu));
              localStorage.setItem("currentUser", JSON.stringify(Info));

              // TODO: Pedir parametros generales y Menu ---- Realizar peticion al servicio

              this.auth.cargarParametros().subscribe(
                (result) => {
                  // data is saved in localStorage inside AuthenticationService, but if you need to do something else
                  // actually, inside AuthenticationService it sets 'parametros', 'fecha'. 
                  // login component used to just do: 'localStorage.setItem("generales", JSON.stringify(data));'
                  // loading parameters via auth.cargarParametros already handles localStorage assignment.

                  let init = {
                    isReload: true,
                  };

                  // Force a reload flag to ensure the dashboard initializes completely
                  localStorage.setItem("init", JSON.stringify(init));
                  this.router.navigateByUrl("dashboard");
                },
                (err) => {
                  console.error("Error cargando parámetros de configuración corporativa: ", err);
                }
              );
            },
            (err) => {
              console.error("Error al validar el token de autenticación: ", err);
            }
          );
          // FIN
        }
      },
      (err) => {
        console.error("Error al procesar los parámetros de la ruta SSO de autenticación.", err);
      }
    );

    this.returnUrl =
      this.srvRoute.snapshot.queryParams["returnUrl"] || "dashboard";
  }
}
